
import Banner from './common/Banner.vue';
import Button from './common/Button.vue';
import SectionHeader from './common/SectionHeader.vue';
import { reachGoal } from './utils/metrika.js';

export default {
  name: 'MeatPageWhereToBuy',
  components: { SectionHeader, Button, Banner },
  props: {
    data: {
      type: Object,
      required: true
    },
    common: {
        type: Object,
        default: () => ({})
    }
  },
  methods: { reachGoal }
}
